import React from 'react'
import PropTypes from 'prop-types'
import { H1, H2, H3 } from './styles.js'

const Headings = ({ level, text }) => {
  switch (level) {
    case 'h1':
      return <H1>{text}</H1>
    case 'h2':
      return <H2>{text}</H2>
    case 'h3':
      return <H3>{text}</H3>
    case 'h4':
      return <h4>{text}</h4>
    case 'h5':
      return <h5>{text}</h5>
    case 'h6':
      return <h6>{text}</h6>
    default:
      return <h2>{text}</h2>
  }
}

Headings.propTypes = {
  level: PropTypes.string,
  text: PropTypes.string,
}

export default Headings
